import Webhooks from 'app/collections/webhooks';
import Webhook from 'app/models/webhook';
import ApiModeSelection from 'app/models/api_mode_selection';

import Base from 'app/views/base';

import PageHeaderView from 'app/components/page_header';
import PanelList from 'app/components/panel_list';
import PopupCreateFormView, { FormField } from 'app/components/popup_create_form';
import ListItemView from './list_item_view';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,
  className: 'webhooks',

  initialize() {
    this.prodApiMode = new ApiModeSelection({ mode: 'production' });
    this.testApiMode = new ApiModeSelection({ mode: 'test' });

    this.prodCollection = new Webhooks([], { apiModeSelection: this.prodApiMode });
    this.testCollection = new Webhooks([], { apiModeSelection: this.testApiMode });

    this.createNewWebhookView = new PopupCreateFormView({
      title: 'Add Webhook',
      objectName: 'Webhook',
      ModelClass: Webhook,
      dropdownSelections: [
        new ApiModeSelection({}),
      ],
      formFields: [
        new FormField({ label: 'Webhook URL', paramKey: 'url', placeholder: 'https://example.com/easypost-webhook' }),
      ],
    });
    this.listenTo(this.createNewWebhookView, 'create', () => {
      this.prodCollection.fetch({ reset: true });
      this.testCollection.fetch({ reset: true });
    });

    this.addSubview('header', 'header', new PageHeaderView({
      name: 'Webhooks',
      links: [
        { name: 'Docs', href: '/docs/api#webhooks' },
        { name: 'Guide', href: '/webhooks-guide' },
      ],
      subViews: [ this.createNewWebhookView ],
    }));
    this.addSubview('prodWebhookList', '#prod_webhook_list', new PanelList({
      title: 'Production Webhooks',
      ListItemView: ListItemView,
      collection: this.prodCollection,
    }));
    this.addSubview('testWebhookList', '#test_webhook_list', new PanelList({
      title: 'Test Webhooks',
      ListItemView: ListItemView,
      collection: this.testCollection,
    }));
  },
});



// WEBPACK FOOTER //
// ./app/components/pages/webhooks_and_events/webhooks/index.js